// moz667: por culpa de vrdemo
var $ = jQuery;

/*
    Carousel
*/
$('.carousel').each(function () {
    var $this = $(this);

    $this.carousel('cycle').on('slide.bs.carousel', function (e) {
        /*
            CC 2.0 License Iatek LLC 2018 - Attribution required
        */
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 4;
        var totalItems = $this.find('.carousel-item').length;
     
        if (idx >= totalItems-(itemsPerSlide-1)) {
            var it = itemsPerSlide - (totalItems - idx);
            // console.log(it);
            for (var i=0; i<it; i++) {
                // append slides to end
                if (e.direction=="left") {
                    $this.find('.carousel-item').eq(i).appendTo($this.find('.carousel-inner'));
                }
                else {
                    $this.find('.carousel-item').eq(0).appendTo($this.find('.carousel-inner'));
                }
            }
        }
    });
});

